<script lang="ts" setup>
import { AppIdentifier } from "@/shared/@types";
import { StatusNotFoundError } from "@/shared/components";
</script>

<template>
  <StatusNotFoundError :button-link="`/${AppIdentifier.Registration}`" />
</template>
